import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { FeeTemplate, FeeFormData } from './types';

interface FeeTemplateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editingFee: FeeTemplate | null;
  form: FeeFormData;
  onFormChange: (form: FeeFormData) => void;
  onSave: () => void;
}

export function FeeTemplateDialog({
  open,
  onOpenChange,
  editingFee,
  form,
  onFormChange,
  onSave
}: FeeTemplateDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{editingFee ? 'Redigera avgiftsmall' : 'Ny avgiftsmall'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Namn *</Label>
            <Input
              value={form.name}
              onChange={(e) => onFormChange({ ...form, name: e.target.value })}
              placeholder="T.ex. Månadsavgift 2025"
              data-testid="fee-name-input"
            />
          </div>
          <div>
            <Label>Beskrivning</Label>
            <Input
              value={form.description}
              onChange={(e) => onFormChange({ ...form, description: e.target.value })}
              placeholder="Valfri beskrivning"
              data-testid="fee-description-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Grundbelopp (kr) *</Label>
              <Input
                type="number"
                value={form.base_amount}
                onChange={(e) => onFormChange({ ...form, base_amount: e.target.value })}
                placeholder="0"
                data-testid="fee-base-amount-input"
              />
            </div>
            <div>
              <Label>Per kvm (kr)</Label>
              <Input
                type="number"
                value={form.per_sqm_amount}
                onChange={(e) => onFormChange({ ...form, per_sqm_amount: e.target.value })}
                placeholder="0"
                data-testid="fee-per-sqm-input"
              />
            </div>
          </div>
          <div>
            <Label>Frekvens</Label>
            <Select
              value={form.frequency}
              onValueChange={(value: 'monthly' | 'quarterly' | 'yearly' | 'once') => 
                onFormChange({ ...form, frequency: value })
              }
            >
              <SelectTrigger data-testid="fee-frequency-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="monthly">Månadsvis</SelectItem>
                <SelectItem value="quarterly">Kvartalsvis</SelectItem>
                <SelectItem value="yearly">Årsvis</SelectItem>
                <SelectItem value="once">Engångs</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="fee-active"
              checked={form.is_active}
              onChange={(e) => onFormChange({ ...form, is_active: e.target.checked })}
              data-testid="fee-active-checkbox"
            />
            <label htmlFor="fee-active" className="text-sm">Aktiv</label>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Avbryt</Button>
          <Button onClick={onSave} data-testid="fee-save-btn">Spara</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
